import { BrowserRouter } from "react-router-dom";
import { Sheet } from "@mui/joy";

import { AuthProvider, QueryProvider, ThemeProvider, ProjectProvider, NotificationProvider } from "../provider";
import { AuthHandler } from "../components";

export default function RootLayout({ children }: { children: React.ReactNode }) {
    return (
        <BrowserRouter>
            <AuthProvider>
                <QueryProvider key="query-provider">
                    <ThemeProvider>
                        <NotificationProvider>
                            <Sheet
                                key="sheet"
                                id={"layout-root"}
                                sx={{ height: "100%", display: "flex", flexDirection: "column" }}
                            >
                                <AuthHandler>{children}</AuthHandler>
                            </Sheet>
                        </NotificationProvider>
                    </ThemeProvider>
                </QueryProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
